import React, { Component } from "react";
import app from "./configs/fireBaseConfig";
import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import { ToastContainer, toast } from "react-toastify";

import taigunBrochure from "../brochure/taigun.pdf";
import virtusBrochure from "../brochure/virtus.pdf";
import tiguanBrochure from "../brochure/tiguan.pdf";

import "react-toastify/dist/ReactToastify.css";

const auth = getAuth(app);
const defaultMinutes = 3;
const defaultSeconds = 0;
export default class BookingTestDrive extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ClientID: this.props.ClientId,
      PixelID: this.props.PixelID,
      isShowSucceesMsg: null,
      isShowError: false,
      checked: true,
      verifiedOtp: false,
      isMobileNumberValid: false,
      enableResendOtpBtn: false,
      enableLoader: false, // send otp loader
      verificationLoader: false,
      isOtpSent: false,
      showTimer: false,
      seconds: defaultSeconds,
      minutes: defaultMinutes,
      validation: {
        nameRegex: {
          regExp: "/^([A-Z])$/",
          value: "",
        },
        email: {
          regExp:
            "/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/",
          value: "",
        },
        mobile: {
          regExp: "/^[6-9]d{9}$/",
          value: "",
        },
      },

      errorMsg: {
        forSalutationError: "",
        forFirstNameError: "",
        forLastNameError: "",
        forEmailError: "",
        forContactError: "",
        forTandcCheckError: "",
        forBrochureError: "",
      },
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleLink = this.handleLink.bind(this);
    this.showSubmitSuccessText = this.showSubmitSuccessText.bind(this);
    this.formValidation = this.formValidation.bind(this);
    this.onCaptchaVerify = this.onCaptchaVerify.bind(this);
    this.onSignInSubmit = this.onSignInSubmit.bind(this);
    this.verifyCode = this.verifyCode.bind(this);
    this.showTimerComponent = this.showTimerComponent.bind(this);
  }

  onCaptchaVerify = function() {
    window.recaptchaVerifier = new RecaptchaVerifier(
      "sign-in-button",
      {
        size: "invisible",
        callback: () => {},
      },
      auth
    );
  };

  componentDidMount() {
    try {
      this.onCaptchaVerify();
    } catch (error) {}
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  showTimerComponent = function() {
    this.myInterval = setInterval(() => {
      const { seconds, minutes } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);

          this.setState({
            seconds: defaultSeconds,
            minutes: defaultMinutes,
            showTimer: false,
          });
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
        }
      }
    }, 1000);
  };

  onSignInSubmit = function() {
    this.setState({ enableLoader: true });
    let formElement = document.getElementById(this.props.formId);
    const data = new FormData(formElement);
    let contact = data.get("mobile");
    const phoneNumber = this.props.countryCode + contact;
    const appVerifier = window.recaptchaVerifier;
    signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        window.confirmationResult = confirmationResult;

        toast.success(
          "OTP number has been sent on entered mobile number. Please enter the OTP number in the field below",
          {
            position: "top-center",
          }
        );
        this.showTimerComponent();

        this.setState({
          isOtpSent: true,
          enableResendOtpBtn: true,
          showTimer: true,
          enableLoader: false,
        });

        if (window && window.gtag) {
          window.gtag("event", "otp_requested", {
            car: this.props.carDisplayName
          });
        }
      })
      .catch((error) => {
        toast.error(
          this.getErrorCodeToMessage(error?.code) || "Error while sending OTP",
          {
            position: "top-center",
          }
        );
        this.setState({ enableLoader: false, showTimer: false });
        // Error; SMS not sent
      });
  };

  verifyCode = function(event) {
    event.preventDefault();
    let formElement = document.getElementById(this.props.formId);
    const data = new FormData(formElement);
    let contactOtp = data.get("otp");
    this.setState({
      verificationLoader: true,
    });
    window.confirmationResult
      .confirm(contactOtp)
      .then((result) => {
        // User signed in successfully.
        const user = result.user;
        toast.success("Vertification Done", {
          position: "top-center",
        });
        this.setState({
          verificationLoader: false,
        });
        this.setState({ verifiedOtp: true }, () => {
          this.handleInput();
          setTimeout(() => {
            this.setState({
              showTimer: false,
            });
          }, 1000);
        });

        if (window && window.gtag) {
          window.gtag("event", "otp_verified", {
            car: this.props.carDisplayName
          });
        }
        // ...
      })
      .catch((error) => {
        this.setState({
          verificationLoader: false,
        });
        toast.error("Invalid OTP", {
          position: "top-center",
        });
        // User couldn't sign in (bad verification code?)
        // ...
      });
  };

  handleLink = function(event) {
    //this.setState({ checked: !this.state.checked });
    const target = event.target;
    const value = target.checked;

    this.setState({ checked: value });
  };

  handleInput = function() {
    let formElement = document.getElementById(this.props.formId);
    if (this.state.isShowError && formElement) {
      const data = new FormData(formElement);
      let selectSalutation = data.get("selectSalutation");
      let fullName = data.get("firstName");
      let lastName = data.get("lastName");
      let email = data.get("email");
      let contact = data.get("mobile");
      let tandcCheck = data.get("tandcCheck");
      let brochure = data.get("brochure");
      this.formValidation(
        selectSalutation,
        fullName,
        lastName,
        email,
        contact,
        tandcCheck,
        brochure
      );
    }
    const data = new FormData(formElement);
    let contact = data.get("mobile");
    if (contact?.length >= 10) {
      this.setState({
        isMobileNumberValid: true,
      });
    } else {
      this.setState({
        isMobileNumberValid: false,
      });
    }
  };

  formValidation = function(
    selectSalutation,
    fullName,
    lastName,
    email,
    contact,
    tandcCheck
    //brochure
  ) {
    let emailRegex = new RegExp(
      "^[a-z0-9._\\-+]+@[a-z0-9_\\-]+(\\.[a-z0-9]{2,4}){1,2}$"
    );
    let nameRegex = new RegExp("^[a-zA-Z\\s]{2,50}$");
    let contactRegex = new RegExp("^(\\+91)?[6-9][0-9]{9}$");
    let flag = true;
    let selectSalutationError = "";
    let fullNameError = "";
    let lastNameError = "";
    let emailError = "";
    let contactError = "";
    let tandcCheckError = "";
    //let brochureError = "";

    if (selectSalutation === this.props.salutationDefaultValue) {
      selectSalutationError = "please select salutation";
      flag = false;
    }

    if (!fullName) {
      fullNameError = "Please enter your first name";
      flag = false;
    } else if (!nameRegex.test(fullName)) {
      fullNameError =
        "The first name should include alphabets only and should be between 2 to 50 characters.";
      flag = false;
    }

    if (!lastName) {
      lastNameError = "Please enter your last name";
      flag = false;
    } else if (!nameRegex.test(lastName)) {
      lastNameError =
        "The last name should include alphabets only and should be between 2 to 50 characters.";
      flag = false;
    }

    if (!email) {
      emailError = "Please enter your email address";
      flag = false;
    } else if (!emailRegex.test(email)) {
      emailError = "Please enter a valid email address";
      flag = false;
    }

    if (!contact) {
      contactError = "Please enter your mobile number";
      flag = false;
    } else if (!contactRegex.test(contact)) {
      contactError = "Please enter a valid 10 digit mobile number";
      flag = false;
    } else if (contact === "9876543210") {
      contactError = "Please enter a valid mobile number";
      flag = false;
    } else if (
      `${contact || ""}`.length > 1 &&
      `${contact || ""}`.split("").every((v) => v === `${contact[0] || ""}`)
    ) {
      contactError = "Please enter a valid mobile number";
      flag = false;
    } else if (window.localStorage.getItem("mobileNumber") === contact) {
      contactError =
        "You have already requested a test drive with this mobile number";
      flag = false;
    } else if (!this.state.verifiedOtp) {
      contactError = "Please click on Send OTP and verify the mobile number";
      flag = false;
    }

    if (!tandcCheck) {
      tandcCheckError = "Please accept the terms and conditions";
      flag = false;
    }

    // if (!brochure) {
    //   brochureError = "Please select brochure";
    //   flag = false;
    // }

    this.setState({
      isShowError: true,
      errorMsg: {
        forSelectSalutationError: selectSalutationError,
        forFirstNameError: fullNameError,
        forLastNameError: lastNameError,
        forContactError: contactError,
        forEmailError: emailError,
        forTandcCheckError: tandcCheckError,
        //forBrochureError: brochureError,
      },
    });

    return flag;
  };

  handleSubmit = function(event) {
    event.preventDefault();
    const data = new FormData(event.target);
    let selectSalutation = data.get("selectSalutation");
    let fullName = data.get("firstName");
    let lastName = data.get("lastName");
    let email = data.get("email");
    let contact = data.get("mobile");
    let combinationFullName = selectSalutation + fullName + " " + lastName;

    email = email.trim();
    contact = contact.trim();
    fullName = fullName.trim();
    lastName = lastName.trim();

    let selectCar = data.get("selectCar");

    let tandcCheck = data.get("tandcCheck");
    let brochure = data.get("brochure");
    if (
      this.formValidation(
        selectSalutation,
        fullName,
        lastName,
        email,
        contact,
        tandcCheck,
        brochure
      )
    ) {
      if (this.state.checked) {
        let brochureFile = "";
        switch (selectCar) {
          case "Taigun":
            brochureFile = taigunBrochure;
            break;
          case "Virtus":
            brochureFile = virtusBrochure;
            break;
          case "Tiguan":
            brochureFile = tiguanBrochure;
            break;
          default:
            break;
        }

        if (brochureFile) {
          const link = document.createElement("a");
          link.href = brochureFile;
          link.download = `${selectCar}.pdf`;
          link.click();
        }
      }

      if (window._googleLeadForm) {
        window._googleLeadForm({
          name: combinationFullName,
          mobileNumber: contact,
          email: email,
          model: selectCar,
        });

        this.showSubmitSuccessText();
        window.localStorage.setItem("mobileNumber", contact);
        document.getElementById(this.props.formId).reset();
        this.setState({
          isShowError: false,

          verifiedOtp: false,
          isMobileNumberValid: false,
          enableResendOtpBtn: false,
          enableLoader: false,
          isOtpSent: false,
          showTimer: false,
          minutes: defaultMinutes,
          seconds: defaultSeconds,
        });

        if (window && window.gtag) {
          window.gtag("event", "generate_lead", {});
        }
      } else {
        console.error("Error while submitting lead!");
      }
    }
  };
  showSubmitSuccessText = function() {
    this.setState(
      {
        isShowSucceesMsg: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            isShowSucceesMsg: false,
          });
        }, 5000);
      }
    );
  };

  handleKeyPressForMobile = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    if (!/^\d+$/.test(keyValue) || event.target.value.length === 10) {
      event.preventDefault();
    }
  };

  getErrorCodeToMessage = (code) => {
    const errorMap = {
      "auth/too-many-requests": "Too many attempts, Please try again later",
      "auth/code-expired": "OTP has expired, Please request OTP again",
      "auth/invalid-verification-code": "Invalid OTP, Please enter correct OTP",
      "auth/network-request-failed":
        "We encountered network error,  please check your network or try after sometime",
    };

    return code ? errorMap[code] : null;
  };

  render() {
    const { minutes, seconds } = this.state;
    return (
      <div className="container-fluid sign-fuild">
        <div className="container sign-up-container">
          <ToastContainer />
          <div id="sign-in-button" style={{ visibility: "hidden" }} />
          <div className="test-drive-form">
            <div className="main-heading">Sign up for test drive</div>
            <form
              onSubmit={this.handleSubmit}
              id={this.props.formId}
              className="driveform"
            >
              <div className="form-row">
                <div
                  className={`col-md-${this.props.gridSize} flex-content form-group`}
                >
                  <select
                    className="form-select"
                    id="selectSalutation"
                    name="selectSalutation"
                    onChange={this.handleInput}
                    required
                  >
                    <option>{this.props.salutationDefaultValue}</option>
                    <option>Mr.</option>
                    <option>Miss.</option>
                    <option>Mrs.</option>
                  </select>
                  <div className="formErrorGuidText">
                    {this.state.errorMsg.forSelectSalutationError}
                  </div>
                </div>
                <div
                  className={`col-md-${this.props.gridSize} flex-content form-group`}
                >
                  <input
                    onChange={this.handleInput}
                    type="text"
                    className="form-control"
                    id="firstName"
                    placeholder="First Name"
                    name="firstName"
                    defaultValue={this.props.firstName}
                  />
                  <div className="formErrorGuidText">
                    {this.state.errorMsg.forFirstNameError}
                  </div>
                </div>
                <div
                  className={`col-md-${this.props.gridSize} flex-content form-group`}
                >
                  <input
                    onChange={this.handleInput}
                    type="text"
                    className="form-control"
                    id="lastName"
                    placeholder="Last Name"
                    name="lastName"
                    defaultValue={this.props.lastName}
                  />
                  <div className="formErrorGuidText">
                    {this.state.errorMsg.forLastNameError}
                  </div>
                </div>
                <div
                  className={`col-md-${this.props.gridSize} flex-content form-group`}
                >
                  <input
                    onChange={this.handleInput}
                    type="text"
                    className="form-control"
                    id="email"
                    aria-describedby="emailHelp"
                    placeholder="Email"
                    name="email"
                  />
                  {
                    <div className="formErrorGuidText">
                      {this.state.errorMsg.forEmailError}
                    </div>
                  }
                </div>
                <div
                  className={`col-md-${this.props.gridSize} flex-content form-group`}
                >
                  <div className="otp-btn">
                    <input
                      onChange={this.handleInput}
                      type="number"
                      maxLength={10}
                      className="form-control"
                      id="mobile"
                      placeholder="Mobile Number"
                      name="mobile"
                      defaultValue={this.props.mobileNumber}
                      onKeyPress={this.handleKeyPressForMobile}
                      // disabled={this.state.verifiedOtp ? "disabled" : ""}
                    />
                    {!this.state.enableResendOtpBtn ? (
                      <>
                        <input
                          type="button"
                          value="Send OTP"
                          onClick={this.onSignInSubmit}
                          className="mobile-otp-btn"
                          disabled={
                            this.state.enableLoader ||
                            !this.state.isMobileNumberValid
                          }
                        />
                        {this.state.enableLoader ? (
                          <i
                            className="fa fa-spinner fa-spin fa-1x fa-fw spin-icon"
                            aria-hidden="true"
                          ></i>
                        ) : null}
                      </>
                    ) : (
                      <>
                        <input
                          type="button"
                          value="Resend OTP"
                          onClick={this.onSignInSubmit}
                          className="mobile-otp-btn resend-otp-btn"
                          disabled={
                            this.state.enableLoader || (!this.state.isMobileNumberValid && !this.state.verifiedOtp) || this.state.verifiedOtp
                          }
                        />
                        {this.state.enableLoader ? (
                          <i
                            className="fa fa-spinner resend-spin fa-spin fa-1x fa-fw spin-icon"
                            aria-hidden="true"
                          ></i>
                        ) : null}
                      </>
                    )}
                  </div>
                  <div className="formErrorGuidText">
                    {this.state.errorMsg.forContactError}
                  </div>
                </div>
                <div
                  className={`col-md-${this.props.gridSize} flex-content form-group`}
                >
                  <div className="otp-btn">
                    <input
                      onChange={this.handleInput}
                      type="number"
                      maxLength={10}
                      className="form-control"
                      id="otp"
                      placeholder="Mobile OTP"
                      name="otp"
                      onKeyPress={this.handleKeyPressForMobile}
                      disabled={
                        !this.state.isOtpSent || this.state.verifiedOtp
                          ? "disabled"
                          : ""
                      }
                    />
                    <>
                      <input
                        type="button"
                        className="mobile-otp-btn"
                        value={this.state.verifiedOtp ? "Verified" : "Verify"}
                        disabled={
                          !this.state.isOtpSent ||
                          this.state.verifiedOtp ||
                          !this.state.showTimer ||
                          this.state.verificationLoader
                            ? "disabled"
                            : ""
                        }
                        onClick={this.verifyCode}
                      />
                      {this.state.verificationLoader ? (
                        <i
                          className="fa fa-spinner fa-spin fa-1x fa-fw spin-icon verify-spin"
                          aria-hidden="true"
                        ></i>
                      ) : null}
                    </>
                    {this.state.showTimer ? (
                      <span className="otptimer">
                        {minutes}:{seconds < 10 ? `0${seconds}` : seconds} Min.
                      </span>
                    ) : null}
                  </div>
                </div>
                <div
                  className={`col-md-${this.props.gridSize} flex-content form-group`}
                >
                  <label htmlFor="selectCar" className="form-label">
                    Select a Model
                  </label>
                  <select
                    className="form-select"
                    id="selectCar"
                    name="selectCar"
                    required
                  >
                    <option value="" disabled selected>
                      Select a model
                    </option>
                    {this.props.carList.map((value) => {
                      const valueDisplayName = this.props.carDisplayNames?.[value];
                      const valueForLead = this.props.carDisplayNameForLeads?.[value];
                      return (
                        <option
                          selected={
                            valueForLead === this.props.carDisplayNameForLead
                          }
                          key={`${valueForLead}`}
                          value={valueForLead}
                        >
                          {valueDisplayName}
                        </option>
                      );
                    })}
                  </select>
                  <div className="formErrorGuidText" />
                </div>
                <div className="col-md-12 flex-content form-group form-check">
                  <input
                    type="checkbox"
                    onChange={this.handleInput}
                    className={`form-check-input ${
                      this.state.errorMsg.forTandcCheckError ? "error" : ""
                    }`}
                    id="tandcCheck"
                    name="tandcCheck"
                    checked
                  />
                  <label className="form-check-label" htmlFor="tandcCheck">
                    I accept the
                    <a
                      href="https://www.volkswagen.co.in/en.html/"
                      className="termsCond"
                      target="_blank"
                    >
                      Terms &amp; Conditions
                    </a>
                  </label>
                </div>
                <div className="col-md-12 flex-content form-group form-check">
                  <input
                    type="checkbox"
                    onChange={this.handleLink}
                    className={`form-check-input ${
                      this.state.errorMsg.forBrochureError ? "error" : ""
                    }`}
                    id={`${this.props.formId}brochure`}
                    name={`${this.props.formId}brochure`}
                    checked={this.state.checked}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`${this.props.formId}brochure`}
                  >
                    Get the brochure
                  </label>
                </div>
                <div className="text-center d-flex gap-2 form-button-check flex-column">
                  {this.state.isShowSucceesMsg && (
                    <div className="success-msg-block">
                      <p className="text-success">
                        Your Test Drive request has been submitted successfully.
                      </p>
                    </div>
                  )}
                  <button type="submit" className="btn formSubmit">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

BookingTestDrive.defaultProps = {
  gridSize: 12,
  formId: "bookDrive",
  salutationDefaultValue: "Salutation",
  countryCode: "+91",
};
